export enum TEXT_KEYS {
  COMPETITION = 'promoNotificationActivityCompetition',
  NEWS = 'promoNotificationActivityNews',
  EVENT = 'promoNotificationActivityEvent',
}

export const TEXT_KEYS_NAME: Record<TEXT_KEYS, string | undefined> = {
  [TEXT_KEYS.COMPETITION]: 'Competition',
  [TEXT_KEYS.NEWS]: 'News',
  [TEXT_KEYS.EVENT]: 'Event',
};

export const ALL_TEXT_KEYS = Object.entries(TEXT_KEYS).map(([key, value]) => value);
